import { ExporterCustomBlock, } from "./custom_blocks/SDKExporterCustomBlock";
import { ExporterCustomBlockVariant, } from "./custom_blocks/SDKExporterCustomBlockVariant";
import { ExporterConfigurationProperty, } from "./custom_properties/SDKExporterConfigurationProperty";
import { ExporterPropertyDefinitionArray } from "./custom_properties/SDKExporterPropertyArray";
import { ExporterPropertyDefinitionBoolean } from "./custom_properties/SDKExporterPropertyBoolean";
import { ExporterPropertyDefinitionCode } from "./custom_properties/SDKExporterPropertyCode";
import { ExporterPropertyDefinitionEnum } from "./custom_properties/SDKExporterPropertyEnum";
import { ExporterPropertyDefinitionNumber } from "./custom_properties/SDKExporterPropertyNumber";
import { ExporterPropertyDefinitionObject } from "./custom_properties/SDKExporterPropertyObject";
import { ExporterPropertyDefinitionString } from "./custom_properties/SDKExporterPropertyString";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- -- - --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class Exporter {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        this.id = data.id;
        this.packageId = data.packageId;
        this.isPrivate = data.isPrivate;
        this.isDefaultDocumentationExporter = data.isDefaultDocumentationExporter;
        this.isOwner = data.isOwner;
        this.usesBrands = data.usesBrands;
        // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
        this.usesThemes = data.usesThemes;
        this.usesContext = (_a = data.usesContext) !== null && _a !== void 0 ? _a : false;
        this.name = data.name;
        this.description = (_b = data.description) !== null && _b !== void 0 ? _b : null;
        this.version = data.version;
        this.author = (_c = data.author) !== null && _c !== void 0 ? _c : null;
        this.organization = (_d = data.organization) !== null && _d !== void 0 ? _d : null;
        this.homepage = (_e = data.homepage) !== null && _e !== void 0 ? _e : null;
        this.readme = (_f = data.readme) !== null && _f !== void 0 ? _f : null;
        this.iconURL = (_g = data.iconURL) !== null && _g !== void 0 ? _g : null;
        this.tags = (_h = data.tags) !== null && _h !== void 0 ? _h : [];
        this.exporterType = data.exporterType;
        this.gitProvider = data.gitProvider;
        this.gitUrl = data.gitUrl;
        this.gitBranch = (_j = data.gitBranch) !== null && _j !== void 0 ? _j : null;
        this.gitDirectory = (_k = data.gitDirectory) !== null && _k !== void 0 ? _k : null;
        this.isDeprecated = data.isDeprecated;
        this.replacementExporterId = (_l = data.replacementExporterId) !== null && _l !== void 0 ? _l : null;
        this.deprecationNote = (_m = data.deprecationNote) !== null && _m !== void 0 ? _m : null;
        const variants = new Array();
        if (data.blockVariants) {
            Object.entries(data.blockVariants).forEach(([key, value]) => {
                value.forEach((v) => {
                    variants.push(new ExporterCustomBlockVariant(v, key));
                });
            });
        }
        const resolvedProperties = (_o = data.properties) === null || _o === void 0 ? void 0 : _o.map((property) => {
            if (property.type === "Array") {
                return new ExporterPropertyDefinitionArray(property);
            }
            if (property.type === "Boolean") {
                return new ExporterPropertyDefinitionBoolean(property);
            }
            if (property.type === "Code") {
                return new ExporterPropertyDefinitionCode(property);
            }
            if (property.type === "Enum") {
                return new ExporterPropertyDefinitionEnum(property);
            }
            if (property.type === "Number") {
                return new ExporterPropertyDefinitionNumber(property);
            }
            if (property.type === "Object") {
                return new ExporterPropertyDefinitionObject(property);
            }
            if (property.type === "String") {
                return new ExporterPropertyDefinitionString(property);
            }
            return undefined;
        }).filter((property) => property !== undefined);
        this.contributes = {
            blockVariants: variants,
            blocks: data.customBlocks
                ? data.customBlocks.map((b) => new ExporterCustomBlock(b))
                : [],
            properties: resolvedProperties !== null && resolvedProperties !== void 0 ? resolvedProperties : [],
            configuration: data.configurationProperties
                ? data.configurationProperties.map((c) => new ExporterConfigurationProperty(c, null))
                : [], // in this case, configuration property is just settings and so it doesn't have value
        };
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Utilities
    get usesConfiguration() {
        // Configuration is only available when the exporter provides some properties
        return this.contributes.properties.length > 0;
    }
}
